<template>
  <FileViewContainer>
    <template #default="{ viewFile }">
      <FileCard :file="fileView" :aspect-ratio="4 / 3">
        <template #extra>
          <base-button
            icon
            @click.stop="viewFile(fileView, type)"
            :disabled="!fileView.path"
          >
            <v-icon> mdi-eye </v-icon>
          </base-button>
        </template>
      </FileCard>
    </template>
  </FileViewContainer>
</template>

<script>
import FileCard from '@components/file/file-card.vue'
import FileViewContainer from '@components/file/file-view-container.vue'
import { convertLinkToBackEnd } from '@utils'
export default {
  components: { FileViewContainer, FileCard },
  props: {
    url: { required: true },
    type: { type: String, default: 'image' },
  },
  data: () => ({}),
  computed: {
    fileView() {
      return {
        name: this.fileName,
        file_type: this.type,
        type: this.type,
        path: convertLinkToBackEnd(this.url),
      }
    },
    fileName() {
      if (!this.url) return ''
      return this.url.split(/(\\|\/)/g).pop()
    },
  },
  methods: {},
}
</script>

<style scoped></style>
